import { FilterSingleCheckbox } from '../baseInputTypes/FilterSingleCheckbox'

type Props = {}
export const GERP = (props: Props) => {
  return (
    <FilterSingleCheckbox label="GERP" fieldPath="productInformation.GERP" />
  )
}
